export {
	createFabricElement,
	isTextType,
	isImageType,
	isSvgType,
	ALLOWED_TEXT_TYPES
} from './factory';
